export const GRIPS_DEVICE_IOS_APP = 'ios';
export const GRIPS_DEVICE_ANDROID_APP = 'android';

export type DEVICE_PARAM_TYPE =
  | typeof GRIPS_DEVICE_IOS_APP
  | typeof GRIPS_DEVICE_ANDROID_APP
  | null;

export const CHECKOUT_URL_PARAMS = {
  customerId: 'customerId',
  correlationId: 'correlationId',
  transactionId: 'transactionId',
  paymentProvider: 'paymentProvider',
  expressFallback: 'expressFallback',
  entryTimeStamp: 'entryTimeStamp',
  clientEntryTimeStamp: 'clientEntryTimeStamp',
  device: 'device',
  hash: 'hash',
  authToken: 'authToken',
  authProvider: 'authProvider',
  showSecondaryPriceLabel: 'showSecondaryPriceLabel',
  hasDatadogConsent: 'hdc',
};
